<template>
    <div>
        <Basic :IsPembayaran="true" :IsPaymentSettled="IsPaymentSettled" />
        <SuratPenunjangList class="mt-4" :IsPembayaran="true" :IsPaymentSettled="IsPaymentSettled" />
    </div>
</template>

<script>
export default {
    name: 'SuratPenunjangPembayaran',
    components: {
        Basic: () => import('./Basic.vue'),
        SuratPenunjangList: () => import('./Forms/SuratPenunjangList.vue'),
    },
    props: {
        IsPaymentSettled: {
            type: Boolean,
            default: false
        }
    },
}
</script>